/**
 * Created by sxp23 on 1/18/2018.
 */
import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

import * as L from "leaflet";
import * as esri from "esri-leaflet";
import booleanPointInPolygon from "@turf/boolean-point-in-polygon";

import { CommonService } from "../common.service";
import { SharedService } from "../shared.service";

@Component({
  selector: "nys-esri-map",
  templateUrl: "./esrimap.component.html",
  styleUrls: ["./esrimap.component.css"],
})
export class EsriMapComponent implements OnInit, OnDestroy {
  homeLat: any;
  homeLng: any;
  homeAdr: string;
  subscription: Subscription;

  nysMap; // = L.Map;
  homeMarker;
  layersControl;

  dohMarkers = [];
  dohLayerGroup;
  dohPWSLayerGroup;
  dohPWSLayerGroup1;
  dohPWSLayerGroup2;
  dohPWSLayerGroup3;
  selectedPWSLat;
  selectedPWSLng;

  pwlShoreLineLayer;
  pwlRiverLayer;
  pwlEstuaryLayer;
  pwlLakeLayer;
  isPWSSelected = false;
  isPWLSelected = false;
  showOrHide = "Hide";
  mobile = false;

  baseMaps = {
    Topographic: esri.basemapLayer("Topographic"),
    Satellite: L.layerGroup([
      esri.basemapLayer("Imagery"),
      esri.basemapLayer("ImageryLabels"),
    ]),
    Streets: esri.basemapLayer("Streets"),
    "National Geographic": esri.basemapLayer("NationalGeographic"),
  };

  options = {
    zoom: 12,
    //zoomControl:false,
    //renderer: L.canvas(),  //added for performance improvement
    center: L.latLng(42.736424, -75.762713), //42.652580,-73.756233),
    doubleClickZoom: false,
    attributionControl: false,
    minZoom: 9,
    maxZoom: 18, //,maxNativeZoom: 17
    maxBounds: new L.LatLngBounds(
      new L.LatLng(37.2478212015543, -87.20947265625001),
      new L.LatLng(48.16608541901253, -64.20410156250001)
    ), //South,west  , north,east
  };

  basePath: string;
  constructor(
    private commonService: CommonService,
    private sharedService: SharedService
  ) {
    const hostName = window.location.hostname;
    if (hostName.indexOf("uatwater.ny.gov") != -1) {
      this.basePath =
        "https://uatpubgis.health.ny.gov/arcgis/rest/services/WI_PWL2019/MapServer/";
    } else if (hostName.indexOf("evalwater.ny.gov") != -1) {
      this.basePath =
        "https://evalpubgis.health.ny.gov/arcgis/rest/services/WI_PWL2019/MapServer/";
    } else if (hostName.indexOf("devwater.ny.gov") != -1) {
      this.basePath =
        "https://devpubgis.health.ny.gov/arcgis/rest/services/WI_PWL2019/MapServer/";
    } else if (hostName.indexOf("water.ny.gov") != -1) {
      this.basePath =
        "https://pubgis.health.ny.gov/arcgis/rest/services/WI_PWL2019/MapServer/";
    } else {
      this.basePath =
        "https://devpubgis.health.ny.gov/arcgis/rest/services/WI_PWL2019/MapServer/";
      //this.basePath = "http://wapdevgis01:6080/arcgis/rest/services/WI_PWL2019_v2/MapServer/";
      //this.basePath = "http://wapdevgis01:6080/arcgis/rest/services/WI_PWL2019/MapServer/";
    }
    this.subscription = sharedService.homeAddress$.subscribe((addres) => {
      var locHref = location.href;
      if (addres && locHref.substr(locHref.lastIndexOf("/")) === "/waterMaps") {
        var address = JSON.parse(addres);
        if (address.text && address.magicKey) {
          this.commonService
            .getLngLatForAddress(address.text, address.magicKey)
            .subscribe(
              (addres) => {
                this.homeLat = addres.candidates[0].location.y;
                this.homeLng = addres.candidates[0].location.x;
                this.homeAdr = addres.candidates[0].address;
              },
              (err) =>
                console.error(
                  "Error in getLngLatForAddress() at Water System Map::",
                  err
                ),
              () => {
                //Finally block
                this.nysMap.removeLayer(this.homeMarker);
                this.homeMarker = L.marker([this.homeLat, this.homeLng], {
                  //marker for home address
                  icon: L.icon({
                    iconAnchor: [9, 18],
                    popupAnchor: [0, -18],
                    iconUrl: "assets/images/home3.png",
                  }),
                });
                this.homeMarker.addTo(this.nysMap);
                this.homeMarker.bindPopup("Address : " + this.homeAdr);

                //if (this.sharedService.getFlowFlag() === "DOH" || this.isPWSSelected) {
                if (this.isPWSSelected) {
                  var selectedPwsId;
                  var localThis = this;
                  try {
                    if (this.dohPWSLayerGroup1) {
                      this.dohPWSLayerGroup1.eachLayer(function (layer) {
                        if (
                          booleanPointInPolygon(
                            localThis.homeMarker.toGeoJSON(),
                            layer.toGeoJSON()
                          )
                        ) {
                          selectedPwsId = layer.feature.properties.PWS_Number;
                        }
                      });
                    }
                    if (this.dohPWSLayerGroup2 && !selectedPwsId) {
                      this.dohPWSLayerGroup2.eachLayer(function (layer) {
                        if (
                          booleanPointInPolygon(
                            localThis.homeMarker.toGeoJSON(),
                            layer.toGeoJSON()
                          )
                        ) {
                          selectedPwsId = layer.feature.properties.PWS_Number;
                        }
                      });
                    }
                    if (this.dohPWSLayerGroup3 && !selectedPwsId) {
                      this.dohPWSLayerGroup3.eachLayer(function (layer) {
                        if (
                          booleanPointInPolygon(
                            localThis.homeMarker.toGeoJSON(),
                            layer.toGeoJSON()
                          )
                        ) {
                          selectedPwsId = layer.feature.properties.PWS_Number;
                        }
                      });
                    }
                  } catch (err) {
                    console.log(
                      "Error at Address Change constructor at Water Map",
                      err
                    );
                  } finally {
                    this.commonService
                      .getDOHMapPWS(this.homeLat, this.homeLng)
                      .subscribe(
                        (pwsMapdata) => {
                          if (!selectedPwsId) {
                            this.selectedPWSLat = pwsMapdata[0].latitude;
                            this.selectedPWSLng = pwsMapdata[0].longitude;
                            selectedPwsId = pwsMapdata[0].pwsId;
                          } else {
                            for (let pwsMap of pwsMapdata) {
                              if (selectedPwsId === pwsMap.pwsId) {
                                this.selectedPWSLat = pwsMap.latitude;
                                this.selectedPWSLng = pwsMap.longitude;
                              }
                            }
                            if (!this.selectedPWSLat && !this.selectedPWSLng) {
                              this.selectedPWSLat = pwsMapdata[0].latitude;
                              this.selectedPWSLng = pwsMapdata[0].longitude;
                              selectedPwsId = pwsMapdata[0].pwsId;
                            }
                          }
                          if (selectedPwsId !== this.sharedService.getPwsId())
                            this.sharedService.setPwsId(selectedPwsId);
                        },
                        (err) =>
                          console.error("Error in getDOHMapPWS() call::", err),
                        () => {
                          if (this.nysMap._layers[selectedPwsId]) {
                            this.nysMap._layers[selectedPwsId].fire("click");
                            this.nysMap.closePopup();
                          }
                        }
                      );
                  }
                }
                this.nysMap.panTo(new L.LatLng(this.homeLat, this.homeLng));
              }
            );
        }
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onMapClick(pwsId, evt) {
    this.sharedService.setLatLngFrESRIMap(
      '{"lat":"' +
        evt.latlng.lat +
        '","lng":"' +
        evt.latlng.lng +
        '","pwsId":"' +
        pwsId +
        '"}'
    );
    this.sharedService.setFlowFlag2Lat(null);
    this.sharedService.setFlowFlag2Lng(null);
    this.nysMap._layers[pwsId].fire("click");
  }

  private getIconPWL(r: string): string {
    return r == "All Waters&nbsp;&nbsp;"
      ? "assets/images/0000FFFF.png"
      : "assets/images/Greenlegend.png";
  }
  private getIconPWS(r: string): string {
    return r == "PWS Boundary"
      ? "assets/images/pwsBoundary.png"
      : "assets/images/GreenBoundary.png";
  }

  ngOnInit() {
    if (window.screen.width < 768) {
      // 768px portrait
      this.mobile = true;
    }
    if (this.sharedService.getHomeAddress()) {
      var address = JSON.parse(this.sharedService.getHomeAddress());
      if (address.text && address.magicKey) {
        this.commonService
          .getLngLatForAddress(address.text, address.magicKey)
          .subscribe(
            (addres) => {
              this.homeLat = addres.candidates[0].location.y;
              this.homeLng = addres.candidates[0].location.x;
              this.homeAdr = addres.candidates[0].address;
            },
            (err) =>
              console.error(
                "Error in getLngLatForAddress() at Water System Map::",
                err
              ),
            () => {
              //Finally block
              if (!this.homeLat) {
                this.homeLat = 42.736424;
                this.homeLng = -75.762713;
                this.homeAdr = "13072, Georgetown, New York";
              }
              this.populateMap();
            }
          );
      }
    } else {
      if (!this.homeLat) {
        this.homeLat = 42.736424;
        this.homeLng = -75.762713;
        //this.homeAdr = "Muller Hill State Forest, Georgetown, NY 13072, USA";
        this.homeAdr = "13072, Georgetown, New York";
      }
      this.populateMap();
    }
  }

  private populateMap(): void {
    if (!this.homeLat) {
      this.homeLat = 42.736424;
      this.homeLng = -75.762713;
      this.homeAdr = "13072, Georgetown, New York";
      this.sharedService.setHomeAddress(
        '{"homeAddress":"' +
          this.homeAdr +
          '","homeLat":"' +
          this.homeLat +
          '","homeLng":"' +
          this.homeLng +
          '"}'
      );
    }
    /*if (this.sharedService.getFlowFlag() === "DOH") {
      this.options.zoom = 11;
    }
    else{*/
    this.options.zoom = 11;
    //}
    function countyStyle(feature) {
      return {
        interactive: false, // in order to remove hand pointer (Link Select) on County layer
        fillColor: "#B8BF3F", //inside polygon color
        fillOpacity: 0.07, //transparency of fill
        weight: 1, //thickness of outline
        opacity: 1, //transparency of outline
        color: "black", //color of outline
        dashArray: "9", // dash size
      };
    }

    this.nysMap = L.map("NYS-esri-Map", this.options);
    var map = this.nysMap;
    this.createLegendProcessing();
    setTimeout(() => {
      if (document.getElementById("legendDivSpin")) {
        var elem = document.getElementById("legendDivSpin");
        elem.parentNode.removeChild(elem);
      }
    }, 2000);
    this.nysMap.createPane("pane450").style.zIndex = 450; //Lower number is under.
    this.nysMap.createPane("pane620").style.zIndex = 620;

    map.on("layeradd", (e) => {
      this.createLegendProcessing();
      setTimeout(() => {
        if (document.getElementById("legendDivSpin")) {
          var elem = document.getElementById("legendDivSpin");
          elem.parentNode.removeChild(elem);
        }
      }, 2000);
    });

    function zoomToFeature(e) {
      map.fitBounds(e.target.getBounds());
    }

    this.homeMarker = L.marker([this.homeLat, this.homeLng], {
      //marker for home address
      icon: L.icon({
        iconAnchor: [9, 18],
        popupAnchor: [0, -18],
        iconUrl: "assets/images/home3.png",
      }),
    });
    this.homeMarker.addTo(this.nysMap);
    this.homeMarker.bindPopup("Address : " + this.homeAdr);
    var myLayer = L.geoJSON(null, { style: countyStyle }).addTo(this.nysMap);
    this.commonService.getCountyMaps().subscribe(
      (lngLatsdata) => {
        myLayer.addData(lngLatsdata);
      },
      (err) => console.error("Error in getCountyMaps() call::", err),
      () => {}
    );
    var layerWeight = 1;
    this.pwlShoreLineLayer = esri.featureLayer({
      url: this.basePath + "0",
      pane: "pane620",
      useCors: true,
      //url: 'https://www.dec.ny.gov/arcgis/rest/services/WaterQuality/MapServer/1', pane: 'pane620', useCors:false,
      simplifyFactor: 0.5,
      precision: 5,
      minZoom: 9,
      onEachFeature: forEachFeatureRiver,
      style: riverStyle,
    });
    var shoreLayer = this.pwlShoreLineLayer;

    this.pwlRiverLayer = esri.featureLayer({
      url: this.basePath + "1",
      pane: "pane620",
      useCors: true,
      //url: 'https://www.dec.ny.gov/arcgis/rest/services/WaterQuality/MapServer/2', pane: 'pane620', useCors:false,
      minZoom: 9,
      //cacheLayers:true, //no use
      simplifyFactor: 0.5,
      precision: 5,
      onEachFeature: forEachFeatureRiver,
      style: riverStyle,
    });
    var riverLayer = this.pwlRiverLayer;

    this.pwlLakeLayer = esri.featureLayer({
      url: this.basePath + "3",
      pane: "pane620",
      useCors: true,
      //url: 'https://www.dec.ny.gov/arcgis/rest/services/WaterQuality/MapServer/4', pane: 'pane620', useCors:false,
      simplifyFactor: 0.5,
      minZoom: 9,
      precision: 5,
      onEachFeature: forEachFeatureLake,
      style: lakeStyle,
    });
    var lakeLayer = this.pwlLakeLayer;

    this.pwlEstuaryLayer = esri.featureLayer({
      url: this.basePath + "2",
      pane: "pane620",
      useCors: true,
      //url: 'https://www.dec.ny.gov/arcgis/rest/services/WaterQuality/MapServer/3', pane: 'pane620', useCors:false,
      simplifyFactor: 0.5,
      precision: 5,
      minZoom: 9,
      onEachFeature: forEachFeatureLake,
      style: lakeStyle,
    });
    var estuaryLayer = this.pwlEstuaryLayer;

    function riverStyle(feature) {
      //if (feature.geometry.type !== 'MultiLineString' && feature.geometry.type !== 'LineString') console.log("UNKNOWN feature.geometry.type RIVER:", feature.geometry.type);
      //if (feature.geometry.type == 'MultiLineString' || feature.geometry.type == 'LineString') console.log("MultiLineString feature.geometry.type RIVER:", feature.geometry.type);
      //if (feature.properties.WBCATGRY == null) console.log("NULL feature.properties.WBCATGRY RIVER:", feature);
      if (feature.geometry.type === "MultiLineString") {
        return {
          color: "rgba(0, 92, 230, 255)",
          fillColor: "rgba(0, 92, 230, 255)",
          weight: layerWeight,
        };
      } else {
        return {
          fillColor: "rgba(0, 92, 230, 255)",
          fillOpacity: 0.8,
          weight: layerWeight,
          opacity: 1,
          //color: '#000000'
          color: "rgba(0, 92, 230, 255)",
        };
      }
    }
    function lakeStyle(feature) {
      //if (feature.geometry.type !== 'MultiPolygon' && feature.geometry.type !== 'Polygon') console.log("UNKNOWN feature.geometry.type LAKE:", feature.geometry.type, feature.properties.WBCATGRY);
      //if (feature.geometry.type == 'MultiPolygon' || feature.geometry.type == 'Polygon') console.log("MULTIPOLY feature.geometry.type LAKE:", feature.geometry.type, feature.properties.WBCATGRY);
      //if (feature.properties.WBCATGRY == null) console.log("NULL feature.properties.WBCATGRY LAKE:", feature);
      return {
        fillColor: "rgba(0, 92, 230, 255)",
        fillOpacity: 0.8,
        weight: 1,
        opacity: 1,
        color: "#000000",
        //color: this.getColorPWL(feature.properties.WBCATGRY)
      };
    }
    function highlightLine(layerWeightNo) {
      return {
        color: "cyan",
        weight: layerWeightNo,
        opacity: 1,
      };
    }
    function highlightPoly(layerWeightNo) {
      return {
        fillColor: "cyan",
        weight: layerWeightNo,
        opacity: 0.9,
      };
    }
    function forEachFeatureRiver(feature, layer) {
      layer.on("click", function (e) {
        shoreLayer.setStyle(riverStyle);
        riverLayer.setStyle(riverStyle);
        estuaryLayer.setStyle(lakeStyle);
        lakeLayer.setStyle(lakeStyle);
        layer.setStyle(highlightLine(layerWeight));
        //zoomToFeature(e);
      });
    }
    function forEachFeatureLake(feature, layer) {
      layer.on("click", function (e) {
        shoreLayer.setStyle(riverStyle);
        riverLayer.setStyle(riverStyle);
        estuaryLayer.setStyle(lakeStyle);
        lakeLayer.setStyle(lakeStyle);
        layer.setStyle(highlightPoly(layerWeight));
        //zoomToFeature(e);
      });
    }

    var ZoomViewer = L.Control.extend({
      //position: 'topleft', not working
      onAdd: function () {
        //var gauge = L.DomUtil.create('div','leaflet-top leaflet-right');
        var gauge = L.DomUtil.create("div");
        gauge.style.width = "110px";
        gauge.style.background = "#58ACFA";
        gauge.style.textAlign = "center";
        gauge.style.cssFloat = "right";
        gauge.style.border = "1px solid black";
        gauge.innerHTML =
          '<div><b><span style="color:black;font-size:115%;">Zoom Level: ' +
          map.getZoom() +
          "</span></b></div>";
        //map.on('zoomstart zoom zoomend', function(ev){
        map.on("zoomend", function (ev) {
          gauge.innerHTML =
            '<div><b><span style="color:black;font-size:115%;">Zoom Level: ' +
            map.getZoom() +
            "</span></b></div>";
          if (map.getZoom() < 11 && document.getElementById("legendDivPWL"))
            document.getElementById("msgHdr").style.display = "block";
          else document.getElementById("msgHdr").style.display = "none";
          if (riverLayer) {
            switch (map.getZoom()) {
              case 10:
                layerWeight = 1;
                riverLayer.setStyle({ weight: layerWeight });
                shoreLayer.setStyle({ weight: layerWeight });
                break;
              case 11:
                layerWeight = 2;
                riverLayer.setStyle({ weight: layerWeight });
                shoreLayer.setStyle({ weight: layerWeight });
                break;
              case 12:
                layerWeight = 3;
                riverLayer.setStyle({ weight: layerWeight });
                shoreLayer.setStyle({ weight: layerWeight });
                break;
              case 13:
                layerWeight = 4;
                riverLayer.setStyle({ weight: layerWeight });
                shoreLayer.setStyle({ weight: layerWeight });
                break;
              case 14:
                layerWeight = 5;
                riverLayer.setStyle({ weight: layerWeight });
                shoreLayer.setStyle({ weight: layerWeight });
                break;
              case 15:
                layerWeight = 6;
                riverLayer.setStyle({ weight: layerWeight });
                shoreLayer.setStyle({ weight: layerWeight });
                break;
              case 16:
                layerWeight = 7;
                riverLayer.setStyle({ weight: layerWeight });
                shoreLayer.setStyle({ weight: layerWeight });
                break;
              case 17:
                layerWeight = 8;
                riverLayer.setStyle({ weight: layerWeight });
                shoreLayer.setStyle({ weight: layerWeight });
                break;
              case 18:
                layerWeight = 9;
                riverLayer.setStyle({ weight: layerWeight });
                shoreLayer.setStyle({ weight: layerWeight });
                break;
              default:
                riverLayer.setStyle({ weight: 1 });
                shoreLayer.setStyle({ weight: 1 });
            }
          }
          if (document.getElementById("legendDivPWLMsg")) {
            var elem = document.getElementById("legendDivPWLMsg");
            elem.parentNode.removeChild(elem);
          }
        });
        return gauge;
      },
    });
    new ZoomViewer().addTo(this.nysMap);

    setTimeout(() => {
      this.nysMap.invalidateSize();
      L.control.scale().addTo(this.nysMap);
      map.zoomControl.remove();
      //add zoom control back in but in the upper right
      L.control.zoom({ position: "topright" }).addTo(map);
      if (this.sharedService.getFlowFlag2Lat()) {
        this.nysMap.panTo(
          new L.LatLng(
            parseFloat(this.sharedService.getFlowFlag2Lat()),
            parseFloat(this.sharedService.getFlowFlag2Lng())
          )
        );
      } else if (this.sharedService.getLatLngFrESRIMap()) {
        var latLngFrESRI = JSON.parse(this.sharedService.getLatLngFrESRIMap());
        this.nysMap.panTo(new L.LatLng(latLngFrESRI.lat, latLngFrESRI.lng));
      } else {
        this.nysMap.panTo(new L.LatLng(this.homeLat, this.homeLng));
      }
    }, 5);

    //if (this.sharedService.getFlowFlag() === "DOH"){
    //  this.getMapPWS(["dohPWS"]);
    //}
    //else{
    this.getMapPWL(["decPWL"]);
    //}
  }

  private createLegendsAddr(): void {
    if (this.showOrHide === "Hide") {
      let legend = new L.Control({ position: "topleft" });
      let div;
      if (document.getElementById("legendDivAddr")) {
        var elem = document.getElementById("legendDivAddr");
        elem.parentNode.removeChild(elem);
      }
      div = L.DomUtil.create("div", "info legend");
      div.setAttribute("id", "legendDivAddr");
      legend.onAdd = (map) => {
        let labelsList = [];
        labelsList = [" Selected Address&nbsp;&nbsp;"];
        var labels = [];
        div.innerHTML += labels.push(
          '<img src="/doh7/waterqual/assets/images/home3Lgnd.png">' +
            (labelsList[0] ? labelsList[0] : "+")
        );
        //div.innerHTML += labels.push('<img src="/assets/images/home3Lgnd.png">' + (labelsList[0] ? labelsList[0] : '+'));
        div.innerHTML = labels.join("<br>");
        return div;
      };
      legend.addTo(this.nysMap);
    }
  }
  private createLegendsPWS(): void {
    if (this.showOrHide === "Hide") {
      let legend = new L.Control({ position: "topleft" });
      let div;
      if (document.getElementById("legendDivPWS")) {
        var elem = document.getElementById("legendDivPWS");
        elem.parentNode.removeChild(elem);
      }
      div = L.DomUtil.create("div", "info legend");
      div.setAttribute("id", "legendDivPWS");
      legend.onAdd = (map) => {
        let labelsList = [];
        labelsList = ["PWS Boundary", "Selected PWS"];
        var labels = [];
        labels.push("<b>Public Water System</b>"); //Legend Title  pwsBoundary.png
        for (let i = 0; i < labelsList.length; i++) {
          div.innerHTML += labels.push(
            '<img src="' +
              this.getIconPWS(labelsList[i]) +
              '">&nbsp;&nbsp;' +
              (labelsList[i] ? labelsList[i] : "+")
          );
        }
        div.innerHTML = labels.join("<br>");
        return div;
      };
      legend.addTo(this.nysMap);
    }
  }
  private createLegendsPWL(): void {
    if (this.showOrHide === "Hide") {
      let legend = new L.Control({ position: "topleft" });
      let div;
      if (document.getElementById("legendDivPWL")) {
        var elem = document.getElementById("legendDivPWL");
        elem.parentNode.removeChild(elem);
      }
      div = L.DomUtil.create("div", "info legend");
      div.setAttribute("id", "legendDivPWL");
      legend.onAdd = (map) => {
        let labelsList = [];
        labelsList = ["All Waters&nbsp;&nbsp;", "Selected Waters&nbsp;&nbsp;"];
        var labels = [];
        labels.push("<b>NY Waters</b>"); //Legend Title

        for (let i = 0; i < labelsList.length; i++) {
          //div.innerHTML += labels.push('<i  style="background:' + this.getColorPWL(labelsList[i]) + '">  </i>' + (labelsList[i] ? labelsList[i] : '+'));
          div.innerHTML += labels.push(
            '<img src="' +
              this.getIconPWL(labelsList[i]) +
              '">&nbsp;&nbsp;' +
              (labelsList[i] ? labelsList[i] : "+")
          );
        }
        div.innerHTML = labels.join("<br>");
        if (map.getZoom() < 11) {
          //this.createLegendsPWLMsg();
          document.getElementById("msgHdr").style.display = "block";
        }
        return div;
      };
      legend.addTo(this.nysMap);
    }
  }
  private createLegendsPWLMsg(): void {
    let legend = new L.Control({ position: "topright" });
    let div;
    if (document.getElementById("legendDivPWLMsg")) {
      var elem = document.getElementById("legendDivPWLMsg");
      elem.parentNode.removeChild(elem);
    }
    div = L.DomUtil.create("div", "info legend");
    div.setAttribute("id", "legendDivPWLMsg");
    legend.onAdd = (map) => {
      //div.innerHTML = '<i class="fa fa-warning" style="font-size:18px;color:darkred"></i><span style="color:black">NY Waters will be displayed<br/> only if Zoom Level is 10 or above</span>';
      div.innerHTML =
        '<i class="fa fa-warning" style="font-size:18px;color:darkred"></i><span style="color:black">NY Waters loading may take <br/> more time than expected</span>';
      return div;
    };
    legend.addTo(this.nysMap);
  }

  private createLegendProcessing(): void {
    let legend = new L.Control({ position: "topright" });
    let div;
    if (document.getElementById("legendDivSpin")) {
      var elem = document.getElementById("legendDivSpin");
      elem.parentNode.removeChild(elem);
    }
    div = L.DomUtil.create("div", "infoj legendj");
    div.setAttribute("id", "legendDivSpin");
    legend.onAdd = (map) => {
      div.innerHTML =
        '<img src="/doh7/waterqual/assets/images/spinner.gif">';
      //div.innerHTML = '<img  align="center" src="/assets/images/spinner.gif">';
      return div;
    };
    legend.addTo(this.nysMap);
  }

  getMapPWS(selectedLayers: string[]) {
    var localThis = this;
    function PWSStyle(feature) {
      return {
        interactive: true, // in order to remove hand pointer (Link Select) on County layer
        fillColor: "#e8db4c", //inside polygon color 3e76bf  3e46bf
        fillOpacity: 0.3, //transparency of fill
        weight: 1, //thickness of outline
        opacity: 1, //transparency of outline
        color: "orange", //color of outline
        dashArray: "1", // dash size
      };
    }
    function forEachFeature(feature, layer) {
      // Tagging each PWS poly with their PWS ID for the search control.
      layer._leaflet_id = feature.properties.PWS_Number;

      var popupContent =
        '<div class="table-responsive"><table class="table table-sm table-bordered"><thead><tr><th scope="col" colspan="2">' +
        feature.properties.PWS_Name +
        "</th></tr></thead><tbody><tr>" +
        '<th scope="row">PWS ID</th><td>' +
        feature.properties.PWS_Number +
        "</td></tr><tr>" +
        '<th scope="row">County Served</th><td>' +
        feature.properties.Principal_County_Served +
        "</td></tr><tr>" +
        '<th scope="row">Population Served</th><td>' +
        feature.properties.PopServed +
        "</td></tr><tr>" +
        '<th scope="row">Drinking Water Reports</th><td><a href="/doh7/waterqual/#/waterSystems"> Click Here </a></td></tr>' +
        "</tbody></table></div>";

      layer.bindPopup(popupContent);

      var highlight = {
        fillColor: "green",
        weight: 2,
        opacity: 1,
      };
      layer.on("click", function (e) {
        localThis.dohPWSLayerGroup1.setStyle(PWSStyle); //resets layer colors
        localThis.dohPWSLayerGroup2.setStyle(PWSStyle);
        localThis.dohPWSLayerGroup3.setStyle(PWSStyle);
        layer.setStyle(highlight); //highlights selected.
        if (feature.properties.PWS_Number && e.latlng && e.latlng.lat) {
          localThis.sharedService.setLatLngFrESRIMap(
            '{"lat":"' +
              e.latlng.lat +
              '","lng":"' +
              e.latlng.lng +
              '","pwsId":"' +
              feature.properties.PWS_Number +
              '"}'
          );
          localThis.sharedService.setFlowFlag2Lat(null);
          localThis.sharedService.setFlowFlag2Lng(null);
        }
      });
    }
    var selectedPwsId;
    if (selectedLayers.length > 0) {
      this.isPWSSelected = true;
      this.dohPWSLayerGroup1 = L.geoJSON(null, {
        onEachFeature: forEachFeature,
        pane: "pane450",
        style: PWSStyle,
      });
      this.commonService.getPWSBoundaryMaps1().subscribe(
        (lngLatsdata) => {
          this.dohPWSLayerGroup1.addData(lngLatsdata);
        },
        (err) => console.error("Error in getPWSBoundaryMaps1() call::", err),
        () => {
          this.dohPWSLayerGroup1.addTo(this.nysMap);
          this.dohPWSLayerGroup1.bringToFront();
          this.dohPWSLayerGroup1.eachLayer(function (layer) {
            if (
              booleanPointInPolygon(
                localThis.homeMarker.toGeoJSON(),
                layer.toGeoJSON()
              )
            ) {
              selectedPwsId = layer.feature.properties.PWS_Number;
            }
          });

          this.dohPWSLayerGroup2 = L.geoJSON(null, {
            onEachFeature: forEachFeature,
            pane: "pane450",
            style: PWSStyle,
          });
          this.commonService.getPWSBoundaryMaps2().subscribe(
            (lngLatsdata) => {
              this.dohPWSLayerGroup2.addData(lngLatsdata);
            },
            (err) =>
              console.error("Error in getPWSBoundaryMaps2() call::", err),
            () => {
              this.dohPWSLayerGroup2.addTo(this.nysMap);
              this.dohPWSLayerGroup2.bringToFront();
              var isInside2 = false;
              this.dohPWSLayerGroup2.eachLayer(function (layer) {
                if (
                  booleanPointInPolygon(
                    localThis.homeMarker.toGeoJSON(),
                    layer.toGeoJSON()
                  )
                ) {
                  selectedPwsId = layer.feature.properties.PWS_Number;
                }
              });

              this.dohPWSLayerGroup3 = L.geoJSON(null, {
                onEachFeature: forEachFeature,
                pane: "pane450",
                style: PWSStyle,
              });
              this.commonService.getPWSBoundaryMaps3().subscribe(
                (lngLatsdata) => {
                  this.dohPWSLayerGroup3.addData(lngLatsdata);
                },
                (err) =>
                  console.error("Error in getPWSBoundaryMaps3() call::", err),
                () => {
                  this.dohPWSLayerGroup3.addTo(this.nysMap);
                  this.dohPWSLayerGroup3.bringToFront();
                  var isInside3 = false;
                  this.dohPWSLayerGroup3.eachLayer(function (layer) {
                    if (
                      booleanPointInPolygon(
                        localThis.homeMarker.toGeoJSON(),
                        layer.toGeoJSON()
                      )
                    ) {
                      selectedPwsId = layer.feature.properties.PWS_Number;
                    }
                  });

                  this.commonService
                    .getDOHMapPWS(this.homeLat, this.homeLng)
                    .subscribe(
                      (pwsMapdata) => {
                        if (!selectedPwsId) {
                          this.selectedPWSLat = pwsMapdata[0].latitude;
                          this.selectedPWSLng = pwsMapdata[0].longitude;
                          selectedPwsId = pwsMapdata[0].pwsId;
                        } else {
                          for (let pwsMap of pwsMapdata) {
                            if (selectedPwsId === pwsMap.pwsId) {
                              this.selectedPWSLat = pwsMap.latitude;
                              this.selectedPWSLng = pwsMap.longitude;
                            }
                          }
                          if (!this.selectedPWSLat && !this.selectedPWSLng) {
                            this.selectedPWSLat = pwsMapdata[0].latitude;
                            this.selectedPWSLng = pwsMapdata[0].longitude;
                            selectedPwsId = pwsMapdata[0].pwsId;
                          }
                        }
                      },
                      (err) =>
                        console.error("Error in getDOHMapPWS() call::", err),
                      () => {
                        this.dohLayerGroup = L.layerGroup(this.dohMarkers);
                        this.dohLayerGroup.addTo(this.nysMap);

                        if (this.sharedService.getPwsId()) {
                          selectedPwsId = this.sharedService.getPwsId();
                        }

                        if (this.nysMap._layers[selectedPwsId]) {
                          this.nysMap._layers[selectedPwsId].fire("click");
                          this.nysMap.closePopup();
                        }
                      }
                    );
                }
              );
            }
          );
        }
      );
      this.createLegendsPWS();
    } else {
      //this.nysMap.removeLayer(this.dohLayerGroup);
      this.isPWSSelected = false;
      if (this.dohLayerGroup) {
        this.dohLayerGroup.clearLayers();
      }
      if (this.dohPWSLayerGroup) {
        this.dohPWSLayerGroup.clearLayers();
      }
      if (this.dohPWSLayerGroup1) {
        this.dohPWSLayerGroup1.clearLayers();
      }
      if (this.dohPWSLayerGroup2) {
        this.dohPWSLayerGroup2.clearLayers();
      }
      if (this.dohPWSLayerGroup3) {
        this.dohPWSLayerGroup3.clearLayers();
      }
      if (document.getElementById("legendDivPWS")) {
        var elem = document.getElementById("legendDivPWS");
        elem.parentNode.removeChild(elem);
      }
    }
    //L.control.scale().addTo(this.nysMap);
    if (this.layersControl) {
      //this.nysMap.removeLayer(this.baseMaps.Topographic);
      this.layersControl.remove(this.nysMap);
    }
    //Add layer control
    this.layersControl = L.control
      .layers(this.baseMaps, null, { position: "topleft" })
      .addTo(this.nysMap);
    this.baseMaps.Topographic.addTo(this.nysMap);
  }

  toggleLegend() {
    if (this.showOrHide === "Hide") {
      if (document.getElementById("legendDivAddr")) {
        var elem = document.getElementById("legendDivAddr");
        elem.parentNode.removeChild(elem);
      }
      if (document.getElementById("legendDivPWS")) {
        var elem = document.getElementById("legendDivPWS");
        elem.parentNode.removeChild(elem);
      }
      if (document.getElementById("legendDivPWL")) {
        var elem = document.getElementById("legendDivPWL");
        elem.parentNode.removeChild(elem);
      }
      this.showOrHide = "Show";
    } else {
      this.showOrHide = "Hide";
      //this.createLegendsAddr();
      if (this.isPWSSelected) this.createLegendsPWS();
      if (this.isPWLSelected) this.createLegendsPWL();
      if (this.layersControl) {
        //this.nysMap.removeLayer(this.baseMaps.Topographic);
        this.layersControl.remove(this.nysMap);
      }
      //Add layer control
      this.layersControl = L.control
        .layers(this.baseMaps, null, { position: "topleft" })
        .addTo(this.nysMap);
      this.baseMaps.Topographic.addTo(this.nysMap);
    }
  }

  getMapPWL(selectedLayers: string[]) {
    if (selectedLayers.length > 0) {
      this.isPWLSelected = true;
      //this.nysMap.addLayer(this.pwlLayer);
      this.nysMap.addLayer(this.pwlShoreLineLayer);
      this.nysMap.addLayer(this.pwlRiverLayer);
      this.nysMap.addLayer(this.pwlEstuaryLayer);
      this.nysMap.addLayer(this.pwlLakeLayer);
      this.createLegendsPWL();

      this.pwlShoreLineLayer.bindPopup((evt) => {
        //console.log('pwlShoreLineLayer.bindPopup--', evt, evt.feature.geometry);
        return L.Util.template(
          '<div class="table-responsive"><table class="table table-sm table-bordered"><thead><tr><th scope="col" colspan="2">{NAME}</th></tr></thead><tbody><tr>' +
            '<th scope="row">PWL</th><td>{PWL_ID}</td></tr><tr>' +
            //'<th scope="row">Assessment</th><td>{WBCATGRY}</td></tr><tr>' +
            '<th scope="row">Basin</th><td>{BASIN}</td></tr><tr>' +
            '<th scope="row">Waterbody Fact Sheet</th><td><a href="' +
            "{FACT_SHEET}" +
            '" target="_blank"> Click Here <i class="fa fa-external-link"></i></a></td></tr>' +
            //'<th scope="row">Fact Sheet</th><td><a href="https://www.dec.ny.gov/data/WQP/PWL/'+'{PWL_ID}'+'.pdf" target="_blank"> Click Here <i class="fa fa-external-link"></i></a></td></tr>' +
            '<th scope="row">Webpage Link</th><td><a href="https://www.dec.ny.gov/environmental-protection/water" target="_blank"> Click Here <i class="fa fa-external-link"></i></a></td></tr>' +
            "</tbody></table></div>",
          evt.feature.properties
        );
      });
      this.pwlRiverLayer.bindPopup((evt) => {
        //console.log('pwlRiverLayer.bindPopup--', evt, evt.feature.geometry);
        return L.Util.template(
          '<div class="table-responsive"><table class="table table-sm table-bordered"><thead><tr><th scope="col" colspan="2">{NAME}</th></tr></thead><tbody><tr>' +
            '<th scope="row">PWL</th><td>{PWL_ID}</td></tr><tr>' +
            //'<th scope="row">Assessment</th><td>{WBCATGRY}</td></tr><tr>' +
            '<th scope="row">Basin</th><td>{BASIN}</td></tr><tr>' +
            '<th scope="row">Waterbody Fact Sheet</th><td><a href="' +
            "{FACT_SHEET}" +
            '" target="_blank"> Click Here <i class="fa fa-external-link"></i></a></td></tr>' +
            //'<th scope="row">Fact Sheet</th><td><a href="https://www.dec.ny.gov/data/WQP/PWL/'+'{PWL_ID}'+'.pdf" target="_blank"> Click Here <i class="fa fa-external-link"></i></a></td></tr>' +
            '<th scope="row">Webpage Link</th><td><a href="https://www.dec.ny.gov/environmental-protection/water" target="_blank"> Click Here <i class="fa fa-external-link"></i></a></td></tr>' +
            "</tbody></table></div>",
          evt.feature.properties
        );
      });

      this.pwlEstuaryLayer.bindPopup((evt) => {
        //console.log('pwlEstuaryLayer.bindPopup--', evt, evt.feature.geometry);
        return L.Util.template(
          '<div class="table-responsive"><table class="table table-sm table-bordered"><thead><tr><th scope="col" colspan="2">{NAME}</th></tr></thead><tbody><tr>' +
            '<th scope="row">PWL</th><td>{PWL_ID}</td></tr><tr>' +
            //'<th scope="row">Assessment</th><td>{WBCATGRY}</td></tr><tr>' +
            '<th scope="row">Basin</th><td>{BASIN}</td></tr><tr>' +
            '<th scope="row">Waterbody Fact Sheet</th><td><a href="' +
            "{FACT_SHEET}" +
            '" target="_blank"> Click Here <i class="fa fa-external-link"></i></a></td></tr>' +
            //'<th scope="row">Fact Sheet</th><td><a href="https://www.dec.ny.gov/data/WQP/PWL/'+'{PWL_ID}'+'.pdf" target="_blank"> Click Here <i class="fa fa-external-link"></i></a></td></tr>' +
            '<th scope="row">Webpage Link</th><td><a href="https://www.dec.ny.gov/environmental-protection/water" target="_blank"> Click Here <i class="fa fa-external-link"></i></a></td></tr>' +
            "</tbody></table></div>",
          evt.feature.properties
        );
      });

      this.pwlLakeLayer.bindPopup((evt) => {
        //console.log('pwlLakeLayer.bindPopup--', evt, evt.feature.geometry);
        return L.Util.template(
          '<div class="table-responsive"><table class="table table-sm table-bordered"><thead><tr><th scope="col" colspan="2">{NAME}</th></tr></thead><tbody><tr>' +
            '<th scope="row">PWL</th><td>{PWL_ID}</td></tr><tr>' +
            //'<th scope="row">Assessment</th><td>{WBCATGRY}</td></tr><tr>' +
            '<th scope="row">Basin</th><td>{BASIN}</td></tr><tr>' +
            '<th scope="row">Waterbody Fact Sheet</th><td><a href="' +
            "{FACT_SHEET}" +
            '" target="_blank"> Click Here <i class="fa fa-external-link"></i></a></td></tr>' +
            //'<th scope="row">Fact Sheet</th><td><a href="https://www.dec.ny.gov/data/WQP/PWL/'+'{PWL_ID}'+'.pdf" target="_blank"> Click Here <i class="fa fa-external-link"></i></a></td></tr>' +
            '<th scope="row">Webpage Link</th><td><a href="https://www.dec.ny.gov/environmental-protection/water" target="_blank"> Click Here <i class="fa fa-external-link"></i></a></td></tr>' +
            "</tbody></table></div>",
          evt.feature.properties
        );
      });
    } else {
      document.getElementById("msgHdr").style.display = "none";
      this.isPWLSelected = false;
      this.nysMap.removeLayer(this.pwlShoreLineLayer);
      this.nysMap.removeLayer(this.pwlRiverLayer);
      this.nysMap.removeLayer(this.pwlEstuaryLayer);
      this.nysMap.removeLayer(this.pwlLakeLayer);
      if (document.getElementById("legendDivPWL")) {
        var elem = document.getElementById("legendDivPWL");
        elem.parentNode.removeChild(elem);
      }
      if (document.getElementById("legendDivPWLMsg")) {
        var elem = document.getElementById("legendDivPWLMsg");
        elem.parentNode.removeChild(elem);
      }
    }
    //L.control.scale().addTo(this.nysMap);

    if (this.layersControl) {
      this.nysMap.removeLayer(this.baseMaps.Topographic);
      this.layersControl.remove(this.nysMap);
    }

    //Add layer control
    this.layersControl = L.control
      .layers(this.baseMaps, null, { position: "topleft" })
      .addTo(this.nysMap);
    this.baseMaps.Topographic.addTo(this.nysMap);
  }
}
